// Split on sentence-ending punctuation only when followed by whitespace, so
// tokens like "node.js" or "google.com" are not counted as sentence breaks.
const SENTENCE_SPLIT_REGEX = /[.!?]+\s+/;
const MEANINGFUL_SENTENCE_REGEX = /[a-zA-Z]{2,}/;
const SINGLE_SENTENCE_FORMATTING_MIN_LENGTH = 110;

const hasMultipleSentences = (description: string): boolean => {
  const normalized = description.replace(/\s+/g, ' ').trim();
  if (!normalized) {
    return false;
  }

  const sentenceCandidates = normalized
    .split(SENTENCE_SPLIT_REGEX)
    .map((sentence) => sentence.trim())
    .filter((sentence) => sentence.length > 0);

  if (sentenceCandidates.length < 2) {
    return false;
  }

  const meaningfulCandidates = sentenceCandidates.filter((sentence) =>
    MEANINGFUL_SENTENCE_REGEX.test(sentence)
  );

  const candidatesToCount =
    meaningfulCandidates.length > 0 ? meaningfulCandidates : sentenceCandidates;

  return candidatesToCount.length > 1;
};

/**
 * Whether a raw description is worth sending to the AI formatting endpoint:
 * it has multiple sentences or is long enough to benefit from structure.
 */
export const shouldFormatDescription = (description: string): boolean => {
  const trimmed = description.trim();
  if (!trimmed) {
    return false;
  }

  return (
    hasMultipleSentences(trimmed) ||
    trimmed.length > SINGLE_SENTENCE_FORMATTING_MIN_LENGTH
  );
};
